var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_537_8128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 11.9049H14.2853V2.38123H4.76172V0H16.6666V11.9049Z",
    fill: "#B59E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 49.9995C11.2205 49.9995 0.000104595 38.7796 0.000104595 24.9996C-0.0195137 18.2378 2.72139 11.7612 7.58936 7.06845L14.6581 0.327148L16.2947 2.05356L9.24122 8.77961C4.83974 13.0255 2.36215 18.8839 2.38134 24.9996C2.38134 37.4699 12.5301 47.6187 25 47.6187V49.9995Z",
    fill: "#B59E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2379 50.0001H33.333V38.0957H35.7138V47.6193H45.2379V50.0001Z",
    fill: "#B59E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3424 49.6724L33.7053 47.9464L40.7588 41.2204C45.1603 36.9741 47.6383 31.1156 47.6191 24.9999C47.6191 12.53 37.4703 2.38123 25 2.38123V0C38.7799 0 49.9999 11.2204 49.9999 24.9999C50.0199 31.7617 47.2786 38.2384 42.4106 42.9315L35.3424 49.6724Z",
    fill: "#B59E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7945 33.8243L11.5479 21.5777L13.2294 19.8962L23.7945 30.4613L39.1518 15.1045L40.8333 16.786L23.7945 33.8243Z",
    fill: "#B59E9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_537_8128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.cfab4c79b8164b7ef9262ac9b7d38dae.svg";
export { ForwardRef as ReactComponent };